import makeStyles from '@mui/styles/makeStyles'
import { theme } from 'src/providers/ThemeProvider'

export default makeStyles({
  paper: {
    height: '100%',
    maxWidth: '1200px',
    padding: 0,
    borderRadius: '8px'
  },

  dialogTitle: {
    height: '30px',
    color: theme.corporate.secondaryColor,
    background: theme.corporate.primaryColor,
    padding: '8px 16px'
  },

  content: {
    margin: theme.spacing(1.5, 3, 3, 3),
    padding: 0,
    overflow: 'hidden'
  },

  pdfViewer: {
    backgroundColor: '#ddd',
    height: '100%',
    position: 'relative',
    overflow: 'hidden'
  },

  loader: {
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    padding: 32,
    position: 'absolute',
    right: 0,
    top: 0
  }
})
